import type { ReactNode } from 'react';
import { Skeleton } from '@mui/material';
import { cx } from '@trinity/chat-components';
import styles from './style/QuantAnalysis.module.css';

type QuantAnalysisLayoutProps = {
  isLoading: boolean;
  header?: ReactNode;
  actions?: ReactNode;
  sidebar?: ReactNode;
  content?: ReactNode;
};

// Table Layout components similar to sentiment
const TableLayoutBox = ({ children, className }: { children: ReactNode; className?: string }) => {
  return (
    <div className={cx(styles.table, className)}>
      {children}
    </div>
  );
};

const TableLayoutHeader = ({ title, children }: { title: ReactNode; children?: ReactNode }) => {
  return (
    <div className={styles.header}>
      <h1 className={styles.title}>{title}</h1>
      {children}
    </div>
  );
};

export const QuantAnalysisLayout = ({
  isLoading,
  header,
  actions,
  sidebar,
  content,
}: QuantAnalysisLayoutProps) => {
  if (isLoading) {
    return (
      <div className={styles.root}>
        <div className={styles.wrap}>
          <TableLayoutBox>
            <TableLayoutHeader
              title={<Skeleton variant="text" width={200} height={32} />}
            >
              <Skeleton variant="rectangular" width={120} height={36} />
            </TableLayoutHeader>
            <div className={styles.body}>
              <div className={styles.list}>
                <Skeleton variant="rectangular" width="100%" height={40} sx={{ mb: 2 }} />
                {Array.from({ length: 8 }).map((_, i) => (
                  <Skeleton
                    key={i}
                    variant="text"
                    width="100%"
                    height={32}
                    sx={{ mb: 1 }}
                  />
                ))}
              </div>
              <div className={styles.content}>
                <Skeleton variant="rectangular" width="100%" height="100%" />
              </div>
            </div>
          </TableLayoutBox>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.root}>
      <div className={styles.wrap}>
        <TableLayoutBox>
          <TableLayoutHeader title={header}>
            {actions}
          </TableLayoutHeader>
          <div className={styles.body}>
            <div className={styles.list}>
              {sidebar}
            </div>
            <div className={styles.content}>
              {content}
            </div>
          </div>
        </TableLayoutBox>
      </div>
    </div>
  );
};
